/**
 *
 * @module graphQlQuery
 *
 */

import Check from 'check-types';
import queryString from 'query-string';
import HttpMethod from './../configuration/httpMethod';
import GraphQlBuilder from './graphQlBuilder';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    includes,
    string,
    nonEmptyString,
    object
} = Check.assert;

/**
 *
 * @class GraphQlQuery
 * @extends {GraphQlBuilder}
 *
 */
export default class GraphQlQuery extends GraphQlBuilder {

    /**
     *
     * @param {String} query
     * @param {String} [operationName=null]
     * @param {Object} [variables=null]
     *
     */
    constructor(query, operationName = null, variables = null) {

        const errorMessage = {
            ctor: 'GraphQlQuery(query, operationName, variables)',
            get query() {
                return `${this.ctor} query should be a String with length`;
            },
            get operationName() {
                return `${this.ctor} operationName should be a String with length`;
            },
            get variables() {
                return `${this.ctor} variables needs instance of Object`;
            }
        };

        nonEmptyString(query, errorMessage.query, InvalidArgumentException);

        if (Check.assigned(operationName)) {
            string(operationName, errorMessage.operationName, InvalidArgumentException);
        }

        if (Check.assigned(variables)) {
            object(variables, errorMessage.variables, InvalidArgumentException);
        }

        super();

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.query = query;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.operationName = operationName || '';

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.variables = variables || {};

    }


    /**
     *
     * @access private
     * @param {String} url - The URL for which to build the query.
     * @param {HttpMethod} method - The method for which to build the query.
     * @desc Returns the URL for the query.
     * @returns {String} The URL for the query.
     *
     */
    createQueryUrl(url, method) {

        const errorMessage = {
            mthd: 'createQueryUrl(url, method)',
            get url() {
                return `${this.mthd} url should be a String with length`;
            },
            get method() {
                return `${this.mthd} method needs a valid HttpMethod value`;
            }
        };

        nonEmptyString(url, errorMessage.url, InvalidArgumentException);

        includes(
            HttpMethod,
            method,
            errorMessage.method,
            InvalidArgumentException
        );

        let queryUrl = url;

        if (method === HttpMethod.GET) {

            const params = {
                query: this.query || '',
                operationName: this.operationName || '',
                variables: this.variables ? JSON.stringify(this.variables) : ''
            };

            const urlQueryString = queryString.stringify(params);

            queryUrl += `?${urlQueryString}`;

        }

        return queryUrl;

    }

    /**
     *
     * @access private
     * @desc Returns the post content for the query.
     * @returns {String} The post content for the query.
     *
     */
    createPostContent() {

        return JSON.stringify(this);

    }

}



// WEBPACK FOOTER //
// ./src/services/content/graphQlQuery.js